export default __webpack_public_path__ + "beta-maps-guides-migrate-basic-map-960-8040280a96390200f9a5e278da99d2dc.webp";